module.exports = __webpack_public_path__ + "img/vr.90237c45.png";